/* eslint-disable consistent-return */
import axios from "axios"
const ENDPOINT_PREFIX = "/api/admin/"

async function postMetrics(metric: MetricDto):Promise<any> {
  try {
    const url = ENDPOINT_PREFIX + "metrics"
    return await axios.post(url, metric)
  } catch (e) {
    console.log("Exception while posting metrics", e)
  }
}

export async function postTranslateMetrics(textLength: number, recycled: boolean, langFrom: string, langTo: string) {
  await postMetrics({name: "PORTAL_TRANSLATE", value: textLength, properties: {"RECYCLED": recycled.toString(), "LANG_FROM": langFrom, "LANG_TO": langTo}})
}

export async function postCopyMetrics(wasEditedManually: boolean) {
  await postMetrics({name: "PORTAL_TARGET_TEXT_COPY", properties: {"EDITED_MANUALLY": wasEditedManually.toString()}})
}

export async function postAssetCreatedMetrics(wasEditedManually: boolean) {
  await postMetrics({name: "PORTAL_ASSET_CREATED", properties: {"EDITED_MANUALLY": wasEditedManually.toString()}})
}

export async function postTabletVisited(tablet: string) {
  await postMetrics({name: "PORTAL_TABLET_VISITED", properties: {"TABLET": tablet.toUpperCase()}})
}

export async function postJobCreated( langFrom: string, langTo: string, workflow: string) {
  await postMetrics({name: "PORTAL_JOB_CREATED", properties: {"LANG_FROM": langFrom, "LANG_TO": langTo, "WORKFLOW": workflow}})
}

export async function postEditorOpened() {
  await postMetrics({name: "PORTAL_EDITOR_OPENED", properties: {}})
}

interface MetricDto {
  name: string;
  properties: { [key: string]: string };
  value?: number;
}